import React from "react";
import { motion } from "framer-motion";

const CLIENTS = [
  { name: "European SprayDry Technologies", src: "/brand/clients/esdt.png", scale: 1.0 },
  { name: "Thermo Fisher Scientific", src: "/brand/clients/thermofisher.png", scale: 0.55 },
  { name: "Greencore", src: "/brand/clients/greencore.png", scale: 0.75 },
  { name: "Parkacre", src: "/brand/clients/parkacre.png", scale: 0.85 },
  { name: "A-Consult", src: "/brand/clients/aconsult.png", scale: 1.0 },
];

export const Clients = () => {
  // Triple the array so the marquee can loop seamlessly across 50% translate.
  const tripled = [...CLIENTS, ...CLIENTS, ...CLIENTS];

  return (
    <section
      id="clients"
      data-testid="clients-section"
      className="relative bg-[#09090b] py-28 md:py-36 border-y border-white/5 overflow-hidden ambient-depth"
    >
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="relative max-w-7xl mx-auto px-6 md:px-12 mb-14"
      >
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <p className="overline mb-5">— Trusted across the UK</p>
            <h2 className="font-heading text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight max-w-2xl">
              Building with the names that build Britain.
            </h2>
          </div>
          <p className="max-w-xs text-white/50 font-body text-sm">
            A decade of trusted partnerships across food, pharmaceutical and
            industrial sectors.
          </p>
        </div>
      </motion.div>

      <div className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#09090b] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#09090b] to-transparent z-10" />

        <div
          className="marquee-track flex items-center gap-20 md:gap-28 whitespace-nowrap py-4"
          style={{ ["--marquee-distance"]: "33.333%" }}
        >
          {tripled.map((c, i) => (
            <a
              key={`${c.name}-${i}`}
              href="#contact"
              data-testid={`client-logo-${i}`}
              data-cursor-label={c.name}
              aria-label={c.name}
              className="client-logo group shrink-0 flex items-center justify-center h-20 md:h-24 px-2"
            >
              <img
                src={c.src}
                alt={c.name}
                loading="lazy"
                draggable={false}
                style={{ height: `${(c.scale ?? 1) * 100}%` }}
                className="w-auto object-contain select-none"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};
